import ThreadTable from '@/components/thread/ThreadTable';

export default function Threads() {
	return (
		<div className="flex items-center h-full pt-10 flex-col">
			<ThreadTable />
		</div>
	);
}
